import {
  takeLatest,
  call,
  put,
} from 'redux-saga/effects';
import _ from 'lodash';
import { fetchFirmForEditService } from '../../../services/firms';
import * as actions from '../firmsActions';
import { errorOpenModal } from '../../_shared/modal/errorModalActions';

const normalizeEditFirmValues = firm => ({
  ...firm,
  extrn_first_name: `${_.get(firm, 'extrn_first_name', '') || ''}`,
  extrn_last_name: `${_.get(firm, 'extrn_last_name', '') || ''}`,
  extrn_addr_line1: `${_.get(firm, 'extrn_addr_line1', '') || ''}`,
  extrn_addr_line2: `${_.get(firm, 'extrn_addr_line2', '') || ''}`,
  extrn_city_name: `${_.get(firm, 'extrn_city_name', '') || ''}`,
  extrn_st_prov_cd: `${_.get(firm, 'extrn_st_prov_cd', '') || ''}`,
  extrn_postal_cd: `${_.get(firm, 'extrn_postal_cd', '') || ''}`,
});

const normalizeExternalCompanyId = value => {
  const externalCompanyId = Number(value);

  if (!Number.isSafeInteger(externalCompanyId) || externalCompanyId <= 0) {
    throw new Error('Invalid external company ID.');
  }

  return externalCompanyId;
};

export function* fetchEditFirmWorker(action) {
  yield put(actions.loading(true));

  try {
    const externalCompanyId = normalizeExternalCompanyId(_.get(action, 'firmIdentifiers.external_company_id'));

    const response = yield call(fetchFirmForEditService, {
      external_company_id: externalCompanyId,
    });

    const firm = _.get(response, 'data.fetchFirmForEdit');

    if (_.isNil(firm)) {
      throw new Error('Firm user not found.');
    }

    /* Store normalized firm data in Redux state. */
    /* EditFirm passes this as initialValues prop, which triggers enableReinitialize */
    /* to reinitialize the form cleanly - matching the project edit pattern. */
    yield put(actions.setEditFirmData(normalizeEditFirmValues(firm)));
    yield put(actions.loading(false));
  } catch (error) {
    yield call(failure, error);
  }
}

export function* failure(error) {
  yield put(actions.loading(false));
  yield put(
    errorOpenModal({
      title: 'Firm could not be loaded',
      message: 'Unable to load firm details. Please try again or contact support if the issue persists.',
    }),
  );
  yield put(actions.error(error));
}

export default function* fetchEditFirmWatcher() {
  yield takeLatest(actions.FETCH_EDIT_FIRM, fetchEditFirmWorker);
}